export const duplicateBadgeStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  alignSelf: 'flex-start',
  border: ({ palette }) => `1px solid ${palette.error.light}`,
  backgroundColor: ({ palette }) => palette.error.soft ?? palette.background.paper,
  borderRadius: '10px',
  padding: '1px 6px',
  color: ({ palette }) => palette.error.main,
  whiteSpace: 'nowrap',
  mt: '2px',
};
